import axios from "../config/axios"

const BASE = "/external-entities"

export const externalEntityService = {
  // ── External ML Sheets ──────────────────────────────────────────────────

  // GET /api/external-entities/ml-sheets?page=&per_page=&search=&from_location_id=&to_location_id=&vehicle_id=
  getAllExternalML: (page = 1, perPage = 20, filters = {}) => {
    const params = { page, per_page: perPage, ...filters }
    return axios.get(`${BASE}/ml-sheets`, { params })
  },

  // GET /api/external-entities/ml-sheets/<external_ml_id>
  getExternalML: (externalMLId) => {
    return axios.get(`${BASE}/ml-sheets/${externalMLId}`)
  },

  // DELETE /api/external-entities/ml-sheets/<external_ml_id>
  deleteExternalML: (externalMLId) => {
    return axios.delete(`${BASE}/ml-sheets/${externalMLId}`)
  },

  // ── Upload ML Sheet PDF ─────────────────────────────────────────────────

  // POST /api/external-entities/upload-ml-sheet  (multipart: pdf file + user_id)
  uploadMLSheetPDF: (pdfFile, userId) => {
    const formData = new FormData()
    formData.append("pdf", pdfFile)
    formData.append("user_id", userId)
    return axios.post(`${BASE}/upload-ml-sheet`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  // ── External Shipments ──────────────────────────────────────────────────

  // GET /api/external-entities/shipments?page=&per_page=&search=&payment_mode=&from_location_id=&to_location_id=&vehicle_id=&lr_no=
  getAllExternalShipments: (page = 1, perPage = 20, filters = {}) => {
    const params = { page, per_page: perPage, ...filters }
    return axios.get(`${BASE}/shipments`, { params })
  },

  // GET /api/external-entities/shipments/<external_shipment_id>
  getExternalShipment: (externalShipmentId) => {
    return axios.get(`${BASE}/shipments/${externalShipmentId}`)
  },

  // POST /api/external-entities/shipments
  createExternalShipment: (data) => {
    return axios.post(`${BASE}/shipments`, data)
  },

  // PUT /api/external-entities/shipments/<external_shipment_id>
  updateExternalShipment: (externalShipmentId, data) => {
    return axios.put(`${BASE}/shipments/${externalShipmentId}`, data)
  },

  // DELETE /api/external-entities/shipments/<external_shipment_id>
  deleteExternalShipment: (externalShipmentId) => {
    return axios.delete(`${BASE}/shipments/${externalShipmentId}`)
  },

  // ── Shipment Payments ───────────────────────────────────────────────────

  // GET /api/external-entities/shipments/<external_shipment_id>/payments
  getShipmentPayments: (externalShipmentId) => {
    return axios.get(`${BASE}/shipments/${externalShipmentId}/payments`)
  },

  // GET /api/external-entities/shipments/<external_shipment_id>/payments/<payment_id>
  getShipmentPayment: (externalShipmentId, paymentId) => {
    return axios.get(`${BASE}/shipments/${externalShipmentId}/payments/${paymentId}`)
  },

  // POST /api/external-entities/shipments/<external_shipment_id>/payments
  createShipmentPayment: (externalShipmentId, data) => {
    return axios.post(`${BASE}/shipments/${externalShipmentId}/payments`, data)
  },

  // PUT /api/external-entities/shipments/<external_shipment_id>/payments/<payment_id>
  updateShipmentPayment: (externalShipmentId, paymentId, data) => {
    return axios.put(`${BASE}/shipments/${externalShipmentId}/payments/${paymentId}`, data)
  },

  // DELETE /api/external-entities/shipments/<external_shipment_id>/payments/<payment_id>
  deleteShipmentPayment: (externalShipmentId, paymentId) => {
    return axios.delete(`${BASE}/shipments/${externalShipmentId}/payments/${paymentId}`)
  },
}